export default __webpack_public_path__ + "static/media/play-comp.c7985700.webp";